<template>
  <div>
    <p class="page-label">{{ page.number === null ? 'Remaining story pages · selection pending' : `Storybook page ${page.number}` }}</p>
    <MediaPlaceholder :material="page" />
    <p v-if="page.text" class="story-text">{{ page.text }}</p>
    <AudioPlayer :key="page.id" :src="page.audio" label="Page narration" :stage-id="stage.id" :material-id="page.id" :disabled="disabled" transport-controls @action="$emit('action', $event)" />
    <nav class="page-controls" aria-label="Story pages">
      <button class="secondary" :disabled="disabled || state.page_index === 0" @click="$emit('action', { type: 'page', index: state.page_index - 1 })">← Previous page</button>
      <button :disabled="disabled || state.page_index === stage.pages.length - 1" @click="$emit('action', { type: 'page', index: state.page_index + 1 })">Next page →</button>
    </nav>
    <div v-if="stage.questions.length" class="reading-questions"><label v-for="question in stage.questions" :key="question.id">{{ question.prompt }}<textarea :value="state.answers[question.id] || ''" :disabled="disabled" maxlength="2000" @change="$emit('action', { type: 'reader_answer', question_id: question.id, value: $event.target.value })" /></label></div>
    <aside v-else class="placeholder-note">{{ stage.question_placeholder }}</aside>
  </div>
</template>
<script>
import MediaPlaceholder from './MediaPlaceholder.vue';
import AudioPlayer from './AudioPlayer.vue';
export default { components: { MediaPlaceholder, AudioPlayer }, props: { stage: Object, state: Object, disabled: Boolean }, emits: ['action'], computed: { page() { return this.stage.pages[this.state.page_index]; } } };
</script>
